import { Output, EventEmitter, NgZone, ElementRef } from "@angular/core";
import { Component, Input, OnInit } from "@angular/core";
import { fromEvent as observableFromEvent } from 'rxjs';
import { AddressTimetableIntervalDockDto } from "@shared/src/dtos/address/dock/AddressTimetableIntervalDockDto";
import { DockDto } from "@shared/src/dtos/address/dock/DockDto";
import { AddressDaySettingPlanningDockDto } from "@shared/src/dtos/address/dock/AddressDaySettingPlanningDockDto";
import { HColor } from "@shared/src/datatypes/HColor";
import { AddressDockAbsoluteDockDto, AddressDockAbsoluteDto } from "@shared/src/dtos/address/dock/AddressDockAbsoluteDto";
import { DragDropService } from "@shared/src/services/dragdrop/DragDropService";
import { PhaseSlotDto } from "@shared/src/dtos/phase/slot/PhaseSlotDto";
import { HHourInterval } from "@shared/src/public-api";
import { AddressDockIntervalBaseDto } from "@shared/src/dtos/address/dock/AddressDockIntervalBaseDto";

@Component({
  selector: 'shared-docks-planning',
  templateUrl: './shared.docks.planning.component.html',
  styleUrls: ['./shared.docks.planning.component.scss'],
})
export class SharedDocksPlanningComponent implements OnInit {
  constructor(private ele: ElementRef, private ngZone: NgZone, public dragDropService: DragDropService) { 

    this.ngZone.runOutsideAngular(() => {
      observableFromEvent(ele.nativeElement, "dragover")
        .subscribe((event: DragEvent) => {
          this.dragDropService.onDragOver(null, null, event);
        }
        );
    });

  }

  ngOnInit() {

  }

  @Output() onRefreshInterval: EventEmitter<AddressTimetableIntervalDockDto> = new EventEmitter<AddressTimetableIntervalDockDto>();
  refreshInterval(value: AddressTimetableIntervalDockDto) {
    this.onRefreshInterval.next(value);
  }

  @Output() onRefreshData: EventEmitter<any> = new EventEmitter<any>();
  refreshData() {
    this.onRefreshData.next();
  }

  @Output() onDockSelect: EventEmitter<boolean> = new EventEmitter<boolean>();
  dockSelect(value: boolean) {
    this.onDockSelect.next(value);
  }

  public absoluteDto: AddressDockAbsoluteDto;

  private _absolute: boolean = false;
  @Input()
  public set absolute(value: boolean) {
    this._absolute = value;
    this.calculateScreen();
  }
  public get absolute() {
    return this._absolute;
  }
  private _slotsMode: string = "NORMAL";
  @Input()
  public set slotsMode(value: string) {
    this._slotsMode = value;
    this.calculateScreen();
  }
  public get slotsMode() {
    return this._slotsMode;
  }



  private _addressDaySetting: AddressDaySettingPlanningDockDto;
  @Input() public set addressDaySetting(value: AddressDaySettingPlanningDockDto) {
    if (this._addressDaySetting === value)
      return;
    this._addressDaySetting = value;
    this.calculateScreen();
  }
  public get addressDaySetting(): AddressDaySettingPlanningDockDto {
    return this._addressDaySetting;
  }

  public docksDefinedAndNotDefined: Array<DockDto>;
  public calculateScreen() {
    if (this._absolute) {
      this.absoluteDto = AddressDockAbsoluteDto.build(this.addressDaySetting, this.slotsMode);
    } else
      this.absoluteDto = AddressDockAbsoluteDto.buildNull();

    this.docksDefinedAndNotDefined = new Array();
    if(this.addressDaySetting != null && this.addressDaySetting.docksDefinedAndNotDefined != null){
      this.addressDaySetting.docksDefinedAndNotDefined.forEach(x => {
          this.docksDefinedAndNotDefined.push(x);
      });
    }
  }

  getDocks():Array<DockDto>{
    if(this.docksDefinedAndNotDefined == null)
      return new Array<DockDto>();
    return this.docksDefinedAndNotDefined;
  }
  
 
  private _action: string;
  @Input() public set action(value: string) {
    if (this._action === value)
      return;
    this._action = value;
  }
  public get action(): string {
    return this._action;
  }

  getGeneralStyleInterval(value: AddressTimetableIntervalDockDto) {
    if (value != null && value.backColor != null && value.backColor != "")
      return { "backgroundColor": value.backColor };
    else
      return { "backgroundColor": "#ffffff" };
  }

  public pretty(value: any): string {
    return JSON.stringify(value);
  }

  private _dockToAssigned: DockDto;
  @Input() public set dockToAssigned(value: DockDto) {
    if (this._dockToAssigned === value)
      return;
    this._dockToAssigned = value;
  }
  public get dockToAssigned(): DockDto {
    return this._dockToAssigned;
  }

  getTextColor(data: HColor) {
    if (data != null)
      return HColor.getWhiteBlackFromColor(data.web);

    return HColor.getWhiteBlackFromColor(HColor.defaultColor().web);
  }

  getBackColor(data: HColor) {
    return HColor.getColorOrDefaultColor(data, HColor.defaultColor().web);
  }


  //NOMÉS SI ES MODE ABSOLUT

  getInterval(phaseslot: AddressDockIntervalBaseDto): HHourInterval{
    if(phaseslot == null)
      return null;

    return AddressDockIntervalBaseDto.getInterval(phaseslot, this.slotsMode);
  }
  
  drop(event: DragEvent, dock: AddressDockAbsoluteDockDto) {
    if (!dock)
      return;

    if (this.action == PhaseSlotDto.ACTION_ASSIGN_DOCK && DragDropService.isDraggedObjectHardmanType(event)){
        let draggedobject: any = DragDropService.extractDraggedObjectHardmanType(event);
        if (draggedobject != null)
          this.dragDropService.onDrop(DragDropService.extractDraggedObject(event), DragDropService.createDropObject(dock, DragDropService.HARDMAN_ADDRESSDOCKABSOLUTEDOCKDTO), event, this.onDropCallBack, this);
    }
  }
  
  public onDropCallBack(draggedobject: any, ondropobject: any, event: DragEvent, hardmanobjectdragged: any, hardmanobjectdropped: any, callbackparam?: any, result?: any) {
    if (callbackparam && callbackparam.onRefreshData) {
      callbackparam.onRefreshData.next();
    }
  }

}
